import React, { FC, useMemo } from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";

import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    chip: {
      marginTop: "5px",
      maxWidth: "min-content",
    },
    key: {
      marginLeft: "5px",
      width: "100%",
      fontSize: "15px",
      marginTop: "-5px",
    },
    chipCell: {
      padding: "0px 0px 0px 0px",
      width: "50px",
      backgroundColor: "purple",
    },
    table: {
      width: "50px",
    },
    chipParentDiv: {
      // height: "auto",
      // overflowY: "scroll",
    },
    chipContainer: {
      display: "grid",
      gridTemplateColumns: "1fr 9fr",
      width: "100%",
    },
    gridChip1: {
      paddingTop: "12px",
      textAlign: "right",
    },
    gridChip2: {
      fontSize: "15px",
    },
  });

type FilterChipsProps = {
  columns: any[];
  filterData: any;
  handleFilterClear: any;
  sortingData: any;
  removesortingentry: any;
  removeFilterEntry: any;
} & WithStyles<typeof styles>;

const FilterChipsUnstyled: React.FunctionComponent<FilterChipsProps> = (props) => {
  const { filterData, sortingData, removesortingentry, removeFilterEntry, classes, columns } = props;

  const groupedColumns = useMemo(() => {
    return (columns || []).reduce((obj, row) => {
      obj[row.key] = row.name;
      return obj;
    }, {});
  }, [columns]);

  return (
    <div style={{ overflowY: "auto", maxHeight: "84px" }}>
      {Object.keys(sortingData).length > 0 && (
        <Paper>
          <div className={classes.chipParentDiv}>
            <div className={classes.chipContainer}>
              <div className={classes.gridChip1}>{Object.keys(sortingData).length > 0 && <span className={classes.key}>SORTING:</span>}</div>
              <div className={classes.gridChip2}>
                {Object.keys(sortingData).map((item) => (
                  <Chip
                    key={`sorting${item}`}
                    color="secondary"
                    className={classes.chip}
                    onDelete={() => removesortingentry(item)}
                    label={`${groupedColumns[item] || item} ${sortingData[item]}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </Paper>
      )}
      {Object.keys(filterData).length > 0 && (
        <Paper className={classes.chipParentDiv}>
          {Object.keys(filterData).map((key, index) => (
            <div key={`${key}_GridItem`} className={classes.chipContainer}>
              <div className={classes.gridChip1}>
                {(filterData[key].filterTerm || []).length > 0 && (
                  <span key={`${key}_${index}_span`} className={classes.key}>
                    {" "}
                    {(groupedColumns[key] || key).toUpperCase()}:
                  </span>
                )}
              </div>
              <div className={classes.gridChip2} style={{ height: "84px" }}>
                <AutoSizer style={{ marginTop: "2px" }} key={key}>
                  {({ height, width }) => {
                    const CHIP_WIDTH = 100;
                    const chipsPerRow = Math.max(1, Math.floor(width / CHIP_WIDTH));

                    const groupedRows = [];
                    const terms = filterData[key].filterTerm || [];

                    for (let i = 0; i < terms.length; i += chipsPerRow) {
                      groupedRows.push(terms.slice(i, i + chipsPerRow));
                    }

                    return (
                      <List
                        itemSize={34}
                        width={width}
                        height={height}
                        itemCount={groupedRows.length}
                        itemData={{
                          classes,
                          rows: groupedRows,
                          removeFilterEntry,
                          colKey: key,
                        }}
                      >
                        {Row}
                      </List>
                    );
                  }}
                </AutoSizer>
              </div>
            </div>
          ))}
        </Paper>
      )}
    </div>
  );
};

const Row: FC<{ index; style; data }> = ({ index, style, data }) => {
  const { classes, rows, removeFilterEntry, colKey } = data;
  const rowItems = rows[index];

  return (
    <div style={{ ...style, display: "flex", gap: "6px" }}>
      {rowItems.map((option) => (
        <Chip key={`${option.value}`} color="primary" label={option.label} className={classes.chip} onDelete={() => removeFilterEntry(colKey, option.value)} />
      ))}
    </div>
  );
};

export default withStyles(styles)(FilterChipsUnstyled);
